import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { actions as selectActions } from '../reducers/select';
import { getSelectedProduct } from '../utils/productUtils';

export function useSelectedProductOfGroup(groupOfProducts) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [variantSelectors, setVariantSelectors] = useState(null);
  const [hasPromoInGroup, setHasPromoInGroup] = useState(false);
  const [hasPromoOnline, setHasPromoOnline] = useState(false);
  const dispatch = useDispatch();

  /**
   * Actualiza el producto seleccionado en Redux
   */
  const handleChangeSelectedProduct = useCallback(
    (product) => {
      const selectorOption = 'velocidad';

      dispatch(
        selectActions.select({
          data: {
            label: product.selector[selectorOption],
            value: product.selector[selectorOption],
          },
          groupp: groupOfProducts,
          selectedProduct: product,
          selectorOption,
        })
      );
    },
    [dispatch, groupOfProducts]
  );

  /**
   * @param {Object} data
   * @param {string} data.label - propiedad "selector" del producto seleccionado
   * @param {string} data.value - propiedad "selector" del producto seleccionado
   * @param {'velocidad'|'netflix'} selectorOption - propiedad "selector" del producto seleccionado
   *
   * Actualiza el producto seleccionado en Redux. Esta función se usará cuando se cambie
   * el producto seleccionado desde un select de un elemeto de un formulario
   */
  const handleChangeSelectedProductFromSelect = useCallback(
    (data, selectorOption) => {
      dispatch(
        selectActions.select({
          data,
          groupp: groupOfProducts,
          selectedProduct,
          selectorOption,
        })
      );
    },
    [dispatch, groupOfProducts, selectedProduct]
  );

  useEffect(() => {
    const createVariantSelectors = (groupObject, productObject) => {
      const { selector } = groupObject;
      const newDict = '';
      setVariantSelectors(
        Object.keys(selector)
          .reverse()
          .map((eachSelect) => {
            if (selector[eachSelect].length > 0 && selector[eachSelect][0] !== '') {
              if (productObject && productObject.selector) {
                const defaultValue = productObject.selector[eachSelect];

                return {
                  options: selector[eachSelect].map(eachItem => ({
                    value: eachItem,
                    label: eachItem,
                  })),
                  defaultValue: { value: defaultValue, label: defaultValue },
                  onChange: data => handleChangeSelectedProductFromSelect(data, eachSelect),
                }
              }
              return {
                options: [{ value: 'Sin Netflix', label: 'Sin Netflix' }],
                defaultValue: { value: 'Sin Netflix', label: 'Sin Netflix' },
                onChange: data => handleChangeSelectedProductFromSelect(data, 'Sin Netflix'),
              }
            }
            return {
              options: [{ value: 'Sin Netflix', label: 'Sin Netflix' }],
              defaultValue: { value: 'Sin Netflix', label: 'Sin Netflix' },
              onChange: data => handleChangeSelectedProductFromSelect(data, 'Sin Netflix'),
            }
          })

      );
    };

    if (groupOfProducts) {
      const selectedProductInRedux = getSelectedProduct(groupOfProducts);
      setSelectedProduct(selectedProductInRedux);
      setHasPromoOnline(groupOfProducts.hasPromoOnline);
      setHasPromoInGroup(
        Object.keys(groupOfProducts).some(
          eachProduct => eachProduct.includes('fusion')
            && groupOfProducts[eachProduct].recom.promoCode
        )
      );

      createVariantSelectors(groupOfProducts, selectedProductInRedux);
    }
  }, [groupOfProducts, handleChangeSelectedProductFromSelect]);

  return {
    selectedProduct,
    variantSelectors,
    hasPromo: selectedProduct ? !!selectedProduct.recom.promoCode : false,
    hasPromoInGroup,
    setSelectedProduct: handleChangeSelectedProduct,
    setSelectedProductFromSelect: handleChangeSelectedProductFromSelect,
    hasPromoOnline,
  };
}
